<app-poi-sync [id]="driver.id" *ngIf="driver" type="drivers"></app-poi-sync>
